import { React } from "common";
import { UpiApi } from "services";
import PopupDialog from "screens/popups";

const Component = (props) => {

    const { data, onHideClicked } = props;
    const [error, setError] = React.useState(null);

    const OnCancelClicked = (e) => {
        e.preventDefault();
        if (onHideClicked) onHideClicked('execute', true);
    }

    const OnConfirmClicked = async (e) => {
        e.preventDefault();
        setError(null);
        global.Busy(true);
        let rslt = await UpiApi.MandateExecute(data._id);
        global.Busy(false);
        console.log(rslt);
        if (rslt.status !== 100) {
            setError(rslt.statusText);
            return;
        }
        if (onHideClicked) onHideClicked('execute', true);
    }

    const buttons = [{ label: "Confirm", event: OnConfirmClicked }, { label: "Cancel", event: OnCancelClicked }];

    return (
        <>
            <PopupDialog error={error} id={"executePopup"} title={"Execute E-Mandate"} buttons={buttons} width={450} >
                <div className="contentarea_table" style={{ border: 0 }} id="mandateExecute">
                    Are you sure? You want execute?
                </div>
            </PopupDialog>
        </>
    );
};
export default Component;
